/*
 * HONEYWELL INC.,
 * COPYRIGHT (c) 2022
 * ALL RIGHTS RESERVED
 *
 * This software is a copyrighted work and/or information protected as a trade secret.
 * Legal rights of Honeywell Inc. in this software is distinct from ownership of any medium
 * in which the software is embodied. Copyright or trade secret notices included must be
 * reproduced in any copies authorized by Honeywell Inc.
 *
 */

import React, { useContext, useEffect, useState } from 'react';
import IEnergyManagementProps from '../../../DashboardKPIWidgets/IEnergyManagementProps';
import useMounted from '../../../shared/useMount/useMount';
import useConnectorAndDynamicProps from '../../../shared/useConnectorAndDynamicProps/useConnectorAndDynamicProps';
import CarbonScopeTwoDetailWidget from '../CarbonScopeTwoDetailWidget/CarbonScopeTwoDetailWidget';
import CarbonScopeTwoDetailWidgetSeparateAPI from '../CarbonScopeTwoDetailWidget/CarbonScopeTwoDetailWidgetSeparateAPI';
import CarbonScopeTwoSavingsByMeterComponent from '../CarbonScopeTwoSavingsByMeterWidget/CarbonScopeTwoSavingsByMeterComponent';
import {
  IntervalType,
  maxDaysInYear,
  UtilityType
} from '../../../shared/Utils/Constants';
import {
  formattedDate,
  returnFormattedDate
} from '../../../shared/Utils/Utils';
import {
  getCarbonEndDateBasedOnSub,
  getCarbonVDEndDateBasedOnSub
} from '../../../shared/Utils/CarbonViewDetailsUtils';
import {
  EmaasSubscriptionType,
  EnergyUsageDataSourceType,
  SmartPowerSubscriptionType
} from '../../../shared/Enums';
import { ApiContext } from '../../../../context/ApiContext';
import { getEnergyStartDate } from '../../../shared/Utils/EnergyUsagesViewDetailsUtils';
import moment from 'moment';
import { useTranslation } from '@scuf/localization';
import descriptors from '../../../../locales/en-US/descriptors';
import CarbonScopeTwoSavingsByMeterComponentSeparate from '../CarbonScopeTwoSavingsByMeterWidget/CarbonScopeTwoSavingsByMeterComponentSeparate';
import { getIntervalType } from '../../../shared/Utils/PortfolioEnergy/PortfolioEnergyVDUtils';

const CarbonScopeTwoDetailsComponent = (props: IEnergyManagementProps) => {
  const [t] = useTranslation();
  const d = descriptors.energyManagement;
  const { bearerToken, requestContext } = props;
  const isMounted = useMounted();
  const emaasContext = useContext(ApiContext);

  //  const isPremiumSubscription =
  //     requestContext.context.smpSubscriptionType ===
  //     SmartPowerSubscriptionType.PREMIUM_SUBSCRIPTION
  //       ? true
  //       : false;
  const apiContext = useContext(ApiContext);

  const dataSource = requestContext.context.dataSource || '';

  const isSitePremium = apiContext.toggleSeparateApi;

  const [isOutOfRange, setIsOutOfRange] = useState<boolean>(false);

  const getAdjustedEndDate = (userEndDate: string | Date) => {
    // Parse the user's end date
    const userDate = new Date(userEndDate);
    const currentDate = new Date();

    // Check if the user's end date month and year are the same as the current month and year
    if (
      userDate.getMonth() === currentDate.getMonth() &&
      userDate.getFullYear() === currentDate.getFullYear()
    ) {
      // Subtract one month from the user's end date
      userDate.setMonth(userDate.getMonth() - 1);
    }

    return userDate.toISOString();
  };

  // const startDate = getEnergyStartDate(
  //   requestContext.context.startTime!,
  //   requestContext.context.subscriptionType!
  // );
  // const endDate = getCarbonEndDateBasedOnSub(
  //   requestContext.context.subscriptionType!,
  //   requestContext.context.endTime!,
  //   requestContext.context.startTime!
  // );

  const isDateRangeValid = () => {
    const stDate = requestContext.context.startTime
      ? formattedDate(requestContext.context.startTime)
      : '';
    const eDate = moment(
      getCarbonVDEndDateBasedOnSub(
        requestContext.context.subscriptionType!,
        requestContext.context.endTime!,
        requestContext.context.startTime!
      ),
      'YYYY-MM-DD'
    );
    return eDate.diff(stDate, 'days') <= 365;
  };

  const connectorConfig = {
    name: isSitePremium ? 'utility-electricity-summary' : 'utility-electricity',

    options: {
      startDate: requestContext.context.startTime
        ? formattedDate(requestContext.context.startTime)
        : '',
      endDate: getCarbonVDEndDateBasedOnSub(
        requestContext.context.subscriptionType!,
        requestContext.context.endTime!,
        requestContext.context.startTime!,
        dataSource
      ),
      version: apiContext.toggleSeparateApi ? 'v4' : 'v2',
      allDetails: 'true',
      scopeType: 'scope2',
      dataSource: isSitePremium ? dataSource : ''
    }
  };

  const connectorConfigTable = {
    name: 'utility-electricity-table',

    options: {
      startDate: requestContext.context.startTime
        ? formattedDate(requestContext.context.startTime)
        : '',
      endDate: getCarbonVDEndDateBasedOnSub(
        requestContext.context.subscriptionType!,
        requestContext.context.endTime!,
        requestContext.context.startTime!,
        dataSource
      ),
      allDetails: 'true',
      scopeType: 'scope2',
      utilityType: 'electric',
      dataSource
    }
  };

  const connectorConfigForGraph = {
    name: 'utility-electricity-graph',
    options: {
      startDate: requestContext.context.startTime
        ? formattedDate(requestContext.context.startTime)
        : '',
      endDate: getCarbonVDEndDateBasedOnSub(
        requestContext.context.subscriptionType!,
        requestContext.context.endTime!,
        requestContext.context.startTime!,
        dataSource
      ),
      allDetails: 'true',
      scopeType: 'scope2',
      dataSource
      // intervalType: getIntervalType(
      //   requestContext.context.startTime
      //     ? formattedDate(requestContext.context.startTime)
      //     : '',
      //   requestContext.context.endTime
      //     ? formattedDate(requestContext.context.endTime)
      //     : new Date().toISOString()
      // )
    }
  };
  console.log('connectorConfigForGraph', connectorConfigForGraph);
  console.log('requestContext', requestContext);
  // const isMounted = useMounted();

  const [dataConnector] = useConnectorAndDynamicProps({
    connectorConfig,
    requestContext,
    bearerToken
  });

  let dataConnectorForGraph: any;
  if (isSitePremium) {
    dataConnectorForGraph = useConnectorAndDynamicProps(
      {
        connectorConfig: connectorConfigForGraph,
        requestContext,
        bearerToken
      },
      isSitePremium
    )[0];
  }

  let dataConnectorTable: any;
  if (isSitePremium) {
    [dataConnectorTable] = useConnectorAndDynamicProps(
      {
        connectorConfig: connectorConfigTable,
        requestContext,
        bearerToken
      },
      isSitePremium
    );
  }

  useEffect(() => {
    if (!isDateRangeValid()) {
      setIsOutOfRange(true);
    }
  }, []);

  useEffect(() => {
    if (isMounted) {
      if (isDateRangeValid()) {
        setIsOutOfRange(false);
        dataConnector &&
          dataConnector.actions &&
          dataConnector.actions.getAll();

        if (isSitePremium) {
          dataConnectorForGraph &&
            dataConnectorForGraph.actions &&
            dataConnectorForGraph.actions.getAll();
          dataConnectorTable &&
            dataConnectorTable.actions &&
            dataConnectorTable.actions.getAll();
        }
      } else {
        setIsOutOfRange(true);
      }
    }
  }, [requestContext, dataSource]);
  return (
    <div className="total-emissions-scope-two-details">
      {isSitePremium ? (
        <CarbonScopeTwoDetailWidgetSeparateAPI
          dataConnector={dataConnector}
          dataConnectorForGraph={dataConnectorForGraph}
          requestContext={requestContext}
          dataSourceType={props.dataSourceType ? props.dataSourceType : ''}
        />
      ) : (
        <CarbonScopeTwoDetailWidget
          isSite
          dataConnector={dataConnector}
          requestContext={requestContext}
        />
      )}
      {isSitePremium ? (
        <CarbonScopeTwoSavingsByMeterComponentSeparate
          dataConnector={dataConnector}
          dataConnectorTable={dataConnectorTable}
          UtilityBillType={UtilityType.Electricity}
          scope={'scope 2'}
        />
      ) : (
        <CarbonScopeTwoSavingsByMeterComponent
          dataConnector={dataConnector}
          UtilityBillType={UtilityType.Electricity}
          scope={'scope 2'}
        />
      )}
    </div>
  );
};
export default CarbonScopeTwoDetailsComponent;
